import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { PathName } from 'appConstants';

import { toastSuccess } from 'components';
import { ForgotPassword } from 'containers';

import styles from './styles.module.scss';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation('welcome');

  const onFormChange = useCallback(() => {
    toastSuccess(t('Sign_in_password_send_email_', { email }));
    navigate(PathName.SignIn);
  }, [t, email, navigate]);

  return (
    <div className={styles.main_container}>
      <div className={styles.main_content}>
        <ForgotPassword
          onChange={onFormChange}
          email={email}
          setEmail={setEmail}
        />
      </div>
    </div>
  );
};
